import React from 'react';
import { Nav } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import useDataCountry from '../../../hooks/useDataCountry';

const ACCENT_ORANGE = '#f5822a';

/**
 * Navbar trigger for VAN Account modal. Modal must render outside `<Nav as="ul">`
 * (see TopNavRightSideNavItem) — a Modal inside `<ul>` breaks markup and can blank the view.
 *
 * @param {{ onOpen: () => void }} props
 */
const VanAccountNavButton = ({ onOpen }) => {
  const profileDetails = useSelector((state) => state.userProfile.profile);

  const vanBalance = useSelector((state) => state.vanBalance.balance);
  const storedVanCurrency = useSelector((state) => state.vanBalance.currency);
  const dataCountry = useDataCountry();
  const vanCurrency =
    String(dataCountry).toUpperCase() === 'AE' ? 'AED' : storedVanCurrency;

  if (profileDetails?.partnerType !== 'customer') {
    return null;
  }

  const vanDisplay = Number.isFinite(vanBalance)
    ? vanBalance.toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      })
    : '0';

  return (
    <Nav.Item
      as='li'
      className='d-none d-md-flex align-items-center ms-2 me-1'>
      <button
        type='button'
        onClick={onOpen}
        title='Virtual account — Top up'
        className='btn btn-link text-decoration-none px-3 py-2 shadow-none'
        style={{
          border: `1px solid ${ACCENT_ORANGE}`,
          borderRadius: '4px',
          backgroundColor: '#fff',
          lineHeight: 1.15,
        }}>
        <div
          className='fw-bold text-uppercase text-start'
          style={{
            color: ACCENT_ORANGE,
            fontSize: '0.8125rem',
          }}>
          VAN1234569 : {vanDisplay} {vanCurrency}
          
        </div>
        {/* <div style={{display:'block',fontSize:'14px'}}>
          <span className="me-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="currentColor" viewBox="0 0 16 16" style={{verticalAlign: 'text-bottom'}}>
              <path d="M8 1a.5.5 0 0 1 .5.5v6h6a.5.5 0 0 1 0 1h-6v6a.5.5 0 0 1-1 0v-6h-6a.5.5 0 0 1 0-1h6v-6A.5.5 0 0 1 8 1z"/>
            </svg>
          </span>
          Topup
     
        </div> */}
         
      </button>
    </Nav.Item>
  );
};

export default VanAccountNavButton;
